import { useContext } from "react";
import "./Footer.css";
import { domain as d } from "../../settings";
import { CategoryContext, LocaleContext } from "../../AppProvider";
import Logo from "../../assets/icons/logoWithUkr.svg";
import { ReactComponent as MailIcon } from "../../assets/icons/mail.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";
import { ReactComponent as InstagramIcon } from "../../assets/icons/instagram.svg";
import { ReactComponent as FacebookIcon } from "../../assets/icons/facebook.svg";
import { Link } from "react-router-dom";
import { formatCategoryName } from "../../App";
import { getServiceLink } from "../../utilities/misc";

const Footer = () => {
  const { t, locale } = useContext(LocaleContext);
  const [categories] = useContext(CategoryContext);

  const service_link = getServiceLink(locale);
  const domain = d(locale);

  const footLinks: { text: string; link: string }[] =
    locale === "lt"
      ? [
          {
            link: `https://cleanbee.lt/${t("About us Link")}/`,
            text: t("About us")
          },
          {
            link: "https://cleanbee.ie/privacy-policy/",
            text: t("Privacy Policy")
          },
          {
            link: "https://cleanbee.ie/terms-and-conditions/",
            text: t("Rules")
          },
          { link: "https://cleanbee.ie/locations/", text: t("Our locations") },
          { link: "https://admin.cleanbee.lt/", text: t("Cleaners' corner") }
        ]
      : [
          { link: `https://${domain}/about-us/`, text: t("About us") },

          {
            link: `https://${domain}/privacy-policy/`,
            text: t("Privacy Policy")
          },
          {
            link: `https://${domain}/terms-and-conditions/`,
            text: t("Terms and Conditions")
          },

          { link: `https://${domain}/locations/`, text: t("Our locations") },

          { link: `https://${domain}/staff-corner/`, text: t("Staff corner") }
        ];

  return (
    <div className="footer">
      <div className="clean_bee_content">
        <h2 className="footer_title">
          {t("We work with the environment in mind.")}
        </h2>
        <div className="footer_container">
          <div className="footer_info_wrapper">
            <div className="footer_remark flex">
              <img src={Logo} alt="" className="footer_logo" />
              <span className="anchor">
                <span>
                  {t(
                    "Our products have the Bioquest Formula™. They are biodegradable and dermatologically-tested to be allergy-free. They’re also certified by A.I.S.E"
                  )}
                </span>
                <img src={require("../../assets/icons/euFlag.png")} alt="" />
              </span>
            </div>
          </div>
          <div className="footer_link_list_wrapper">
            <h3>Services and Pricelist</h3>
            <ul>
              {categories ? (
                categories
                  .sort((a, b) => (a.position || 0) - (b.position || 0))
                  .map((category, n) => (
                    <li key={n}>
                      <Link
                        to={`/${service_link}/${formatCategoryName(
                          category,
                          false
                        )}`}
                        onClick={() => window.scrollTo({ top: 0 })}
                      >
                        {category.name}
                      </Link>
                    </li>
                  ))
              ) : (
                <></>
              )}
            </ul>
          </div>
          <div className="footer_explore_wrapper">
            <h3>Explore</h3>

            <ul>
              <li>
                <a href="https://cleanbee.ie/new-before-after/">
                  Before &amp; After
                </a>
              </li>
              <li>
                <a href="https://cleanbee.ie/commercial/">Commercial</a>
              </li>
              <li>
                <a href="https://cleanbee.ie/careers/">Careers</a>
              </li>
              <li>
                <a href="https://cleanbee.ie/services/gifts/">Gifts</a>
              </li>
              <li>
                <a href="https://cleanbee.ie/blog/">Blog</a>
              </li>
            </ul>
          </div>
          <div className="footer_contact_wrapper">
            <h3>Contact us</h3>

            <ul>
              <li>
                <MailIcon />
                <a href="mailto:hello@cleanbee.ie">
                  <span>hello@cleanbee.ie</span>
                </a>
              </li>
              <li>
                <MailIcon />
                <a href="mailto:commercial@cleanbee.ie">
                  <span>commercial@cleanbee.ie</span>
                </a>
              </li>
              <li>
                <PhoneIcon />
                <a href="tel:+35316994255">
                  <span>+353 1699 4255</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer_hr"></div>
      <div className="footer_link_wrapper clean_bee_content">
        <div className="footer_link_icon_wrapper">
          <a
            target="_blank"
            href="https://www.instagram.com/cleanbee.ie/"
            rel="noreferrer"
          >
            <InstagramIcon />
          </a>

          <a
            target="_blank"
            href="https://www.facebook.com/cleanbee.ie/"
            rel="noreferrer"
          >
            <FacebookIcon />
          </a>
        </div>
        <ul>
          {footLinks.map(({ link, text }, n) => (
            <li key={n}>
              <a href={link}>{text}</a>
            </li>
          ))}
        </ul>
      </div>
      <div className="footer_hr"></div>
      <div className="clean_bee_content">
        <div className="footer_builder_wrapper">
          <span>© 2024 CleanBee Ltd. All rights reserved</span>
          <a href="https://nordicplum.com/" target="_blank">
            Website by NordicPlum.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
